import { useRef } from 'react'
import {
  Row,
  Col,
  Stack,
  Text,
  Card,
  Tabs,
  Icon,
  Inline
} from '@leroy-merlin-br/backyard-react-ui'
import { Building, User } from '@leroy-merlin-br/backyard-react-icons'
import { Recaptcha } from 'signup/utils'

import { Content } from '../../components'
import { FormPF } from './components/FormPF'
import { FormPJ } from './components/FormPJ'
import * as S from './styled'

const SignUp = () => {
  const recaptchaRef = useRef()
  return (
    <Content>
      <Row>
        <Col
          size={{
            giga: 5
          }}
        >
          <Stack spacing="mega">
            <Card title="Criar conta">
              <Stack spacing="kilo">
                <Tabs
                  items={[
                    {
                      id: 'for you',
                      tab: (
                        <Inline
                          spacing="byte"
                          align="center"
                          justify="center"
                          noWrap
                        >
                          <Icon as={User} />
                          <span>Para você</span>
                        </Inline>
                      ),
                      panel: <FormPF recaptchaRef={recaptchaRef} />
                    },
                    {
                      id: 'to your business',
                      tab: (
                        <Inline
                          spacing="byte"
                          align="center"
                          justify="center"
                          noWrap
                        >
                          <Icon as={Building} />
                          <span>Para sua empresa</span>
                        </Inline>
                      ),
                      panel: <FormPJ recaptchaRef={recaptchaRef} />
                    }
                  ]}
                />

                <Text size="kilo" noMargin>
                  Ao prosseguir, você declara que é maior de idade e que leu e
                  está de acordo com as{' '}
                  <S.Link href="/institucional/termos-e-condicoes-de-uso-do-site">
                    Condições de Uso
                  </S.Link>{' '}
                  e{' '}
                  <S.Link href="/institucional/politica-de-privacidade">
                    {' '}
                    Política de Privacidade
                  </S.Link>{' '}
                  da Leroy Merlin.
                </Text>
              </Stack>
            </Card>
            <Text noMargin>
              Já tem uma conta? <S.Link href="/login">Faça o login</S.Link>.
            </Text>
          </Stack>
        </Col>
      </Row>
      <Recaptcha ref={recaptchaRef} size="invisible" />
    </Content>
  )
}

export default SignUp
